function initializeSlickSlider() {
  $(".product__icon__row").slick({
    arrows: true,
    dots: true,
    infinite: false,
    slidesToShow: 1,
  });
}
// initializeSlickSlider();

var $slick_slider = $(".product__icon__row");
var screen_size = 767;
var settings_slider = {
  dots: true,
  arrows: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 3000,
};

slick_on_mobile($slick_slider, settings_slider);

function slick_on_mobile(slider, settings) {
  $(window).on("load resize", function () {
    if ($(window).width() < screen_size) {
      if (slider.hasClass("slick-initialized")) {
        slider.slick("unslick");
      }
      return;
    }
    if (!slider.hasClass("slick-initialized")) {
      return slider.slick(settings);
    }
  });
}

var windowWidth = $(window).width();

// mobile media slider product

// var $slick_sliderproduct = $('.product__images--no-thumbs .product__slides');
//   var screen_sizeproduct = 767;
//   var settings_sliderproduct = {
//       slidesToShow: 1,
//       slidesToScroll: 1,
//       arrows: false,
//       dots: true,
//       autoplay: false,
//       autoplaySpeed: 5000,
//       infinite: false,
//   }

//   Slick_media( $slick_sliderproduct, settings_sliderproduct);

//   function Slick_media(sliderpro, settings){
//       $(window).on('load resize', function() {
//         if ($(window).width() > screen_sizeproduct) {
//           if (sliderpro.hasClass('slick-initialized')) {
//             sliderpro.slick('unslick');
//           }
//           return
//         }
//         if (!sliderpro.hasClass('slick-initialized')) {
//           return sliderpro.slick(settings);
//         }
//       });
//   };

var $slick_sliderproduct = $(".product__images--no-thumbs .product__slides");
var screen_sizeproduct = 767;
var settings_sliderproduct = {
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  dots: true,
  autoplay: false,
  autoplaySpeed: 5000,
  infinite: false,
};

function Slick_media(sliderpro, settings) {
  $(window).on("load resize", function () {
    if ($(window).width() > screen_sizeproduct) {
      if (sliderpro.hasClass("slick-initialized")) {
        sliderpro.slick("unslick");
      }
      return;
    }
    if (!sliderpro.hasClass("slick-initialized")) {
      sliderpro.slick(settings);
      updatePagination(sliderpro);
      sliderpro.on("afterChange", function (event, slick, currentSlide) {
        updatePagination(sliderpro);
      });
    }
  });
}

function updatePagination(sliderpro) {
  var currentSlide = sliderpro.slick("slickCurrentSlide") + 1;
  var totalSlides = sliderpro.slick("getSlick").slideCount;
  $(".slick-pagination .current-slide").text(currentSlide);
  $(".slick-pagination .total-slides").text(totalSlides);
}

Slick_media($slick_sliderproduct, settings_sliderproduct);

// ==product variant sidebar
console.log($(".selector-wrapper.Size .radio__legend").length);
// console.log($(".selector-wrapper.Size .radio__legend"), "size ");
function drawerOpen() {
  $(".Vaiant_close").click(function () {
    $(".Variant_sidebar").removeClass("active");
    $(".theme__header").removeClass("z-index_auto");
    $(".product__content").removeClass("open_sidebar");
    $("body").css("overflow", "visible");
    $(".accordion").css("background-color", "fff");
    $(".Product_overlay").removeClass("active");
  });
  // console.log($(".selector-wrapper.Size .radio__button"), "size----");

  $(".selector-wrapper.Size .radio__button").click(function () {
    $(this).addClass("selected_size");
    let size_Radios = $(".selector-wrapper.Size .radio__legend").next();
    // console.log(size_Radios, "size_Radios----");
    let size_Radios_size = size_Radios.length;
    // console.log(size_Radios, "size_Radios----");

    const option1Selected = $(".radio__buttons.option-1")
      .children()
      .hasClass("selected_size");
    const option2Selected = $(".radio__buttons.option-2")
      .children()
      .hasClass("selected_size");
    // console.log(option1Selected, "option1Selected----");
    // console.log(option2Selected, "option2Selected----");

    if (size_Radios_size >= 2) {
      if (option1Selected && option2Selected) {
        $(".select--size-mob").text("Add to cart");
        $(".select--size-mob").addClass("cart-trigger");
        // $('.product__submit button').removeClass('Select_a_size');
        $("small.radio__legend__value").css("display", "block");
        $(".add--cart").css("display", "flex");
        $(".select--size").css("display", "none");
        $(".product__price--strike").css("display", "block");
      }
    } else {
      $(".select--size-mob").text("Add to cart");
      $(".select--size-mob").addClass("cart-trigger");
      // $('.product__submit button').removeClass('Select_a_size');
      $("small.radio__legend__value").css("display", "block");
      $(".add--cart").css("display", "flex");
      $(".select--size").css("display", "none");
      $(".product__price--strike").css("display", "block");
    }
  });

  $(".Product_overlay.active").click(function () {
    $(".Variant_sidebar").removeClass("active");
    $(".theme__header").removeClass("z-index_auto");
    $(".product__content").removeClass("open_sidebar");
    $("body").css("overflow", "visible");
    $(".accordion").css("background-color", "fff");
    $(".Product_overlay").removeClass("active");
  });
}
drawerOpen();
//setInterval(drawerOpen, 1000);
$(".add--cart").css("display", "none");

$(".cart-trigger").click(function () {
  $(".product__submit__item .btn").trigger("click");
});

$(".quick-add__button, .product__submit").click(function () {
  // console.log('interval');
  setInterval(drawerOpen, 1000);
});

function Productswip() {
  $(".product_collection_slider .Product-carousel-cell:first-child").hover(
    function () {
      $(".product_collection_slider .Product-carousel-cell:nth-child(2)")
        .parents(".product_collection_slider")
        .slick("slickGoTo", 0);
      $(this).parents(".product_collection_slider").slick("slickNext"); // Move to the next slide
    }
  );

  setTimeout(function () {
    $(".product_collection_slider .slick-slide:nth-child(2)").mouseleave(
      function () {
        $(this).parents(".product_collection_slider").slick("slickGoTo", 0); // Move to the next slide
        // $('.main-carousel').slick('slickPrev');
      }
    );
  }, 1000);
}
Productswip();

const ProductSwip = setInterval(Productswip, 1000);

var count = $(".product_collection_slider").children().length;

if (count >= 1) {
  function myStopFunction() {
    clearInterval(ProductSwip);
  }
}

$(document).ready(function () {
  $(".outer-section li:nth-child(1)").addClass(
    "service-messaging__slider__item"
  );
  $(".outer-section li:nth-child(2)").addClass(
    "service-messaging__slider__item--is-bold"
  );
  $(
    ".outer-section li:nth-child(6), .outer-section li:nth-child(10), .outer-section li:nth-child(14), .outer-section li:nth-child(18)"
  ).addClass(
    "service-messaging__slider__item--is-bold service-messaging__slider__item--first"
  );
   // Helper: get flickity instance (many ways themes attach it)
  function getFlickityInstance() {
    var sliderEl = document.querySelector('.product__slider');
    if (!sliderEl) return null;
    return sliderEl.flickity || sliderEl._flickity || $(sliderEl).data('flickity') || null;
  }

  // Get alt text of the currently selected slide (robust)
  function getSelectedSlideAlt() {
    var $sel = $('.product__slide.is-selected').first();
    if ($sel.length) {
      var alt = $sel.find('figure img').first().attr('alt');
      console.log("alt1233333",alt);
      if (alt && alt.trim() !== '') {
    return alt.trim();
      $sel.find('.model-size').show().removeClass('hidden-alt');
  } else if (!$sel.hasClass('hidden-alt')) {
    $sel.find('.model-size').hide().addClass('hidden-alt');
  }
    }

    var flkty = getFlickityInstance();
    if (flkty && (typeof flkty.selectedIndex === 'number' || typeof flkty.selected === 'number')) {
      var idx = (typeof flkty.selectedIndex === 'number') ? flkty.selectedIndex : flkty.selected;
      var $slide = $('.product__slide').eq(idx);
      if ($slide.length) {
        var alt2 = $slide.find('figure img').first().attr('alt');
        if (alt2 && alt2.trim() !== '') return alt2.trim();
      }
    }

    var $firstVisible = $('.product__slide').filter(function() {
      return $(this).is(':visible');
    }).first();
    if ($firstVisible.length) {
      var alt3 = $firstVisible.find('figure img').first().attr('alt');
      if (alt3 && alt3.trim() !== '') return alt3.trim();
    }

    return ''; 
  }

  // Update the displayed model-size text (global one)
  function updateAltText() {
    var alt = getSelectedSlideAlt();
    console.log("alt----",alt);
    if (alt) {
      $('.model-size-text').text(alt);
    } else {
      $('.model-size-text').text('');
    }
  }

  // 1️⃣ Open by default
  $(".model-size-wrapper").addClass("active");

  // Initial update on page load
  updateAltText();

  // 2️⃣ Toggle on click (open/close)
  $(".model-size-wrapper").on("click", function () {
    $(this).toggleClass("active");
    // updateAltText();

    var symbol = $(this).find(".toggle-symbol");
    if (symbol.length) {
      symbol.text($(this).hasClass("active") ? "-" : "+");
    }
  });

  // 3️⃣ Listen to Flickity events
  var $slider = $('.product__slider');
  if ($slider.length) {
    $slider.on('select.flickity change.flickity settle.flickity', function () {
      updateAltText();
    });

    var sliderEl = $slider.get(0);
    if (sliderEl) {
      var sliderObserver = new MutationObserver(function (mutations) {
        mutations.forEach(function (m) {
          if (m.type === 'attributes' && m.attributeName === 'class') {
            updateAltText();
          }
        });
      });
      sliderObserver.observe(sliderEl, { attributes: true, attributeOldValue: true });
    }
  }

  // 4️⃣ MutationObserver on slides
  var slideNodes = document.querySelectorAll('.product__slide');
  if (slideNodes && slideNodes.length) {
    var slideObserver = new MutationObserver(function (mutations) {
      var shouldUpdate = false;
      mutations.forEach(function (m) {
        if (m.type === 'attributes' && m.attributeName === 'class') {
          var oldVal = m.oldValue || '';
          var newVal = m.target.className || '';
          var had = oldVal.indexOf('is-selected') !== -1;
          var has = newVal.indexOf('is-selected') !== -1;
          if (had !== has) shouldUpdate = true;
        }
      });
      if (shouldUpdate) updateAltText();
    });

    slideNodes.forEach(function (node) {
      slideObserver.observe(node, { attributes: true, attributeOldValue: true });
    });
  }

  // 5️⃣ Precompute per slide: inject alt text into .model-size-text inside each slide
  // $('.product__slide').each(function() {
  //   var altText = $(this).find('figure img').first().attr('alt');
  //   if (altText && altText.trim() !== "") {
  //     $(this).find('.model-size-text').text(altText);
  //   }
  // });

  // 6️⃣ Update on load/resize/visibility change
  $(window).on('load resize visibilitychange', function() {
     $('.product__slide').each(function() {
    var altText = $(this).find('figure img').first().attr('alt');
    if (altText && altText.trim() !== "") {
      $(this).find('.model-size-text').text(altText);
    }
  });

    if (window.innerWidth <= 749) {
      //  $(".model-size-wrapper").addClass("active");
      updateAltText();
    }
  });
    var icon = $(".play , .marquee-content");
  icon.click(function () {
    icon.toggleClass("paused");
    return false;
  });
  $(".moreless-button").click(function () {
    $(".moretext").slideToggle();
    if ($(".moreless-button").text() == "Read more") {
      $(this).text("Read less");
    } else {
      $(this).text("Read more");
    }
  });
});

// ==drawer slider
function cartMatchproduct() {
  var $slick_slider_sidebar = $(".mini-cart__recommendations-list");
  var screen_size = 767;
  var settings_slider_sidebar = {
    dots: true,
    arrows: true,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  slick_on_mobile_side($slick_slider_sidebar, settings_slider_sidebar);

  function slick_on_mobile_side(slider, settings) {
    $(window).on("load resize", function () {
      if ($(window).width() > screen_size) {
        if (slider.hasClass("slick-initialized")) {
          slider.slick("unslick");
        }
        return;
      }
      if (!slider.hasClass("slick-initialized")) {
        return slider.slick(settings);
      }
    });
  }
  $(".drawer_shop_btn").click(function () {
    $(".drawer--cart .drawer__close").click();
  });
}

setInterval(cartMatchproduct, 1000);

$(document).ready(function () {
  jQuery.getJSON("/cart.js", function (cart) {
    var cartcount = cart.item_count;
    console.log("cartcount", cartcount);
    if (cartcount == 0) {
      $(".mini-cart__recommendations").addClass("is-hidden");
    } else {
      $(".mini-cart__recommendations").removeClass("is-hidden");
    }
  });

  $(".cart__item__remove").click(function () {
    jQuery.getJSON("/cart.js", function (cart) {
      var cartcount = cart.item_count;
      console.log("cartcount", cartcount);
      if (cartcount <= 1) {
        $(".mini-cart__recommendations").addClass("is-hidden");
      } else {
        $(".mini-cart__recommendations").removeClass("is-hidden");
      }
    });
  });
});

$(document).ready(function () {
  // Step 1: Only enable hover effect on DESKTOP (non-touch devices)
  function isTouchDevice() {
    return 'ontouchstart' in window || navigator.maxTouchPoints > 0;
  }
  
  // Flag to track if popup is open or button is being clicked
  var popupOpen = false;
  var buttonClicking = false;
  
  // Step 2: Apply hover effect ONLY on desktop and when popup is not open
  if (!isTouchDevice()) {
    // Desktop: Allow hover to show second image (only when popup is closed and button is not being clicked)
    $(".collection_link").hover(
      function () {
        var $productItem = $(this).parent(".grid-item");
        // Don't change image if popup is open, button is being clicked, or button is being hovered
        if (!popupOpen && !buttonClicking && !$productItem.hasClass("button-hover-active")) {
          // Use CSS to handle this, but also set inline style as fallback
          var $bgUnder = $productItem.find(".product-item__bg__under");
          if ($bgUnder.length) {
            $bgUnder.css("opacity", "1");
          }
          // Also handle hover-second-image
          var $hoverSecondImage = $productItem.find(".hover-second-image");
          if ($hoverSecondImage.length) {
            var $firstImage = $hoverSecondImage.find("a:first-child");
            var $secondImage = $hoverSecondImage.find("a:nth-child(2)");
            if ($firstImage.length && $secondImage.length) {
              // Remove any inline styles to let CSS handle it
              $firstImage.each(function() {
                this.style.removeProperty('opacity');
              });
              $secondImage.each(function() {
                this.style.removeProperty('opacity');
              });
            }
          }
        }
      },
      function (e) {
        var $productItem = $(this).parent(".grid-item");
        // Check if mouse is moving to plus icon area - if yes, don't reset image
        var relatedTarget = e.relatedTarget || document.activeElement;
        var $relatedTarget = $(relatedTarget);
        var isMovingToPlusIcon = $relatedTarget.closest('.quick-add__button, [data-quick-add-btn], .quick-add__holder').length > 0 ||
                                 $productItem.find('.quick-add__button, [data-quick-add-btn], .quick-add__holder').is($relatedTarget) ||
                                 $productItem.hasClass("button-hover-active");
        
        // Only reset opacity if not moving to plus icon area
        if (!isMovingToPlusIcon) {
          var $bgUnder = $productItem.find(".product-item__bg__under");
          if ($bgUnder.length) {
            $bgUnder.css("opacity", "");
          }
          // Also reset hover-second-image inline styles
          var $hoverSecondImage = $productItem.find(".hover-second-image");
          if ($hoverSecondImage.length) {
            var $firstImage = $hoverSecondImage.find("a:first-child");
            var $secondImage = $hoverSecondImage.find("a:nth-child(2)");
            if ($firstImage.length && $secondImage.length) {
              $firstImage.each(function() {
                this.style.removeProperty('opacity');
              });
              $secondImage.each(function() {
                this.style.removeProperty('opacity');
              });
            }
          }
        }
      }
    );
  } else {
    // Step 3: Mobile/Touch devices: Completely disable hover effects
    $(".product-item__bg__under").css("opacity", "0");
    
    // Prevent any hover from triggering on touch devices
    $(".collection_link").off("mouseenter mouseleave hover");
    
    // Ensure images never change on touch - prevent all touch-triggered image changes
    // BUT allow image change when touching plus button
    $(document).on("touchstart", ".collection_link, .product-item", function(e) {
      // Check if touch is on plus button - if yes, don't reset image
      var $target = $(e.target);
      var isPlusButton = $target.closest('.quick-add__button, [data-quick-add-btn], .quick-add__holder').length > 0;
      
      if (!isPlusButton) {
        var $productItem = $(this).closest(".grid-item, .product-item");
        if ($productItem.length) {
          $productItem.find(".product-item__bg__under").css("opacity", "0");
        }
      }
    });
  }
  
  // Function to change image to second image - reusable
  function showSecondImage($productItem) {
    try {
      // CRITICAL: Immediately add class to prevent hover interference
      $productItem.addClass("button-hover-active");
      
      // CRITICAL: Add data attribute for CSS specificity
      $productItem.attr("data-image-changed", "true");
      
      // Show second image when clicking plus button
      // Target the hover-second-image container and change opacity of <a> tags
      var $hoverSecondImage = $productItem.find(".hover-second-image");
      if ($hoverSecondImage.length) {
        // Hide first image (opacity 0)
        var $firstImage = $hoverSecondImage.find("a:first-child");
        if ($firstImage.length) {
          $firstImage.each(function() {
            try {
              // Use both setProperty and direct style to ensure it works
              this.style.setProperty('opacity', '0', 'important');
              this.style.opacity = '0';
              // Also set as attribute for maximum compatibility
              this.setAttribute('data-opacity', '0');
            } catch(err) {
              // Silently handle errors
            }
          });
        }
        // Show second image (opacity 1)
        var $secondImage = $hoverSecondImage.find("a:nth-child(2)");
        if ($secondImage.length) {
          $secondImage.each(function() {
            try {
              // Use both setProperty and direct style to ensure it works
              this.style.setProperty('opacity', '1', 'important');
              this.style.opacity = '1';
              // Also set as attribute for maximum compatibility
              this.setAttribute('data-opacity', '1');
            } catch(err) {
              // Silently handle errors
            }
          });
        }
      } else {
        // Fallback: Try using product-item__bg__under if hover-second-image not found
        var $bgUnder = $productItem.find(".product-item__bg__under");
        if ($bgUnder.length) {
          $bgUnder.css("opacity", "1");
        }
      }
      
      // CRITICAL: Store that this product has active image change
      $productItem.data("image-changed", true);
      
      // CRITICAL: Use requestAnimationFrame to ensure styles are applied after any CSS recalculation
      requestAnimationFrame(function() {
        if ($productItem.data("image-changed")) {
          var $hoverSecondImage = $productItem.find(".hover-second-image");
          if ($hoverSecondImage.length) {
            var $firstImage = $hoverSecondImage.find("a:first-child");
            var $secondImage = $hoverSecondImage.find("a:nth-child(2)");
            if ($firstImage.length && $secondImage.length) {
              $firstImage.each(function() {
                try {
                  this.style.setProperty('opacity', '0', 'important');
                  this.style.opacity = '0';
                } catch(err) {}
              });
              $secondImage.each(function() {
                try {
                  this.style.setProperty('opacity', '1', 'important');
                  this.style.opacity = '1';
                } catch(err) {}
              });
            }
          }
        }
      });
    } catch(err) {
      // Silently handle errors
    }
  }
  
  // Show second image when clicking plus button - use mousedown to show image BEFORE click
  // Works on both desktop and mobile
  $(document).on("mousedown", ".quick-add__button, [data-quick-add-btn], .quick-add__holder", function(e) {
    // DON'T stop propagation on button - let click event reach theme.js handler
    // Only stop propagation on holder to prevent collection_link hover
    if ($(this).hasClass('quick-add__holder') && !$(e.target).closest('.quick-add__button, [data-quick-add-btn]').length) {
      e.stopPropagation();
    }
    
    buttonClicking = true;
    var $productItem = $(this).closest(".grid-item, .product-item");
    var $button = $(this).is('.quick-add__button, [data-quick-add-btn]') ? $(this) : $(this).find('.quick-add__button, [data-quick-add-btn]').first();
    
    // CRITICAL: Always show second image first, regardless of popup state
    showSecondImage($productItem);
    
    // CRITICAL: If popup is already open, reset previous product's image first
    // BUT don't reset if this is the same product that already has the popup open
    if (popupOpen) {
      // Reset all other products' images, but keep this one's image change
      $(".grid-item, .product-item").not($productItem).each(function() {
        resetToFirstImage($(this));
      });
      // CRITICAL: Re-apply image to ensure it stays changed
      showSecondImage($productItem);
    }
    
    // CRITICAL: Re-apply image multiple times to ensure it stays changed after refresh
    setTimeout(function() {
      if ($productItem.data("image-changed")) {
        showSecondImage($productItem);
      }
    }, 100);
    
    setTimeout(function() {
      if ($productItem.data("image-changed")) {
        showSecondImage($productItem);
      }
    }, 300);
    
    setTimeout(function() {
      if (popupOpen && $productItem.data("image-changed")) {
        showSecondImage($productItem);
      }
    }, 500);
    
    // Mark that quick-add was clicked to prevent collection_link navigation
    $productItem.data("quick-add-clicked", true);
    
    // Clear the flag after a short delay
    setTimeout(function() {
      $productItem.removeData("quick-add-clicked");
    }, 1000);
    
    // CRITICAL: Ensure button is always clickable and not disabled
    $button.css({
      'pointer-events': 'auto !important',
      'z-index': '1000'
    }).prop('disabled', false).removeClass('is-disabled is-loading');
    
    // Ensure the holder is also clickable
    var $holder = $button.closest('.quick-add__holder');
    if ($holder.length) {
      $holder.css({
        'pointer-events': 'auto !important',
        'z-index': '1000'
      }).removeClass('is-disabled');
    }
  });
  
  // Handle click on button - change image AND ensure theme.js handler runs
  // Use jQuery for better compatibility and reliability
  $(document).on("click", ".quick-add__button, [data-quick-add-btn]", function(e) {
    try {
      var $button = $(this);
      var $productItem = $button.closest(".grid-item, .product-item");
      
      // CRITICAL: Always show second image first, regardless of popup state
      showSecondImage($productItem);
      
      // CRITICAL: If popup is already open, reset previous product's image first
      if (popupOpen) {
        // Reset all other products' images, but keep this one's image change
        $(".grid-item, .product-item").not($productItem).each(function() {
          resetToFirstImage($(this));
        });
        // CRITICAL: Re-apply image to ensure it stays changed
        showSecondImage($productItem);
      }
      
      // CRITICAL: Re-apply image multiple times to ensure it stays changed after refresh
      setTimeout(function() {
        if ($productItem.data("image-changed")) {
          showSecondImage($productItem);
        }
      }, 100);
      
      setTimeout(function() {
        if ($productItem.data("image-changed")) {
          showSecondImage($productItem);
        }
      }, 300);
      
      setTimeout(function() {
        if (popupOpen && $productItem.data("image-changed")) {
          showSecondImage($productItem);
        }
      }, 500);
      
      // CRITICAL: Ensure button is clickable and not disabled
      $button.css({
        'pointer-events': 'auto !important',
        'z-index': '1000'
      }).prop('disabled', false).removeClass('is-disabled is-loading');
      
      // CRITICAL: DON'T stop propagation, DON'T prevent default
      // Let theme.js handler run (it's directly attached to button element)
    } catch(err) {
      // Silently handle errors to prevent console spam
      // Only log if it's a critical error
      if (err.message && !err.message.includes('observer') && !err.message.includes('splide')) {
        console.log('Click handler error:', err);
      }
    }
  });
  
  // iPhone/iOS specific: Handle touch events properly for plus button
  if ('ontouchstart' in window) {
    var touchStartTime = 0;
    var touchStartElement = null;
    
    // Touchstart - show second image and prepare for click
    $(document).on("touchstart", ".quick-add__button, [data-quick-add-btn]", function(e) {
      var $button = $(this);
      var $productItem = $button.closest(".grid-item, .product-item");
      
      // Store touch info
      touchStartTime = Date.now();
      touchStartElement = this;
      
      // CRITICAL: Always show second image first, regardless of popup state
      showSecondImage($productItem);
      
      // CRITICAL: If popup is already open, reset previous product's image first
      // BUT don't reset if this is the same product that already has the popup open
      if (popupOpen) {
        // Reset all other products' images, but keep this one's image change
        $(".grid-item, .product-item").not($productItem).each(function() {
          resetToFirstImage($(this));
        });
        // CRITICAL: Re-apply image to ensure it stays changed
        showSecondImage($productItem);
      }
      
      // CRITICAL: Re-apply image multiple times to ensure it stays changed after refresh
      // Use multiple timeouts with increasing delays to catch any CSS recalculation
      setTimeout(function() {
        if ($productItem.data("image-changed")) {
          showSecondImage($productItem);
        }
      }, 50);
      
      setTimeout(function() {
        if ($productItem.data("image-changed")) {
          showSecondImage($productItem);
        }
      }, 150);
      
      setTimeout(function() {
        if ($productItem.data("image-changed")) {
          showSecondImage($productItem);
        }
      }, 300);
      
      setTimeout(function() {
        if ($productItem.data("image-changed")) {
          showSecondImage($productItem);
        }
      }, 500);
      
      setTimeout(function() {
        if (popupOpen && $productItem.data("image-changed")) {
          showSecondImage($productItem);
        }
      }, 800);
      
      // Prevent hover from triggering
      buttonClicking = true;
      
      // Ensure button is clickable
      $button.css({
        'pointer-events': 'auto !important',
        'z-index': '1000'
      }).prop('disabled', false).removeClass('is-disabled is-loading');
      
      // Mark as clicked
      $productItem.data("quick-add-clicked", true);
    });
    
    // Touchend - trigger click event to ensure theme.js handler runs
    $(document).on("touchend", ".quick-add__button, [data-quick-add-btn]", function(e) {
      var $button = $(this);
      var $productItem = $button.closest(".grid-item, .product-item");
      var touchDuration = Date.now() - touchStartTime;
      
      // Only handle if this is the same element that was touched
      if (touchStartElement === this && touchDuration < 500) {
        // CRITICAL: If popup is already open, ensure current product's image stays changed
        if (popupOpen) {
          // Reset all other products' images, but keep this one's image change
          $(".grid-item, .product-item").not($productItem).each(function() {
            resetToFirstImage($(this));
          });
          // CRITICAL: Ensure current product's image stays changed
          showSecondImage($productItem);
          
          // CRITICAL: Re-apply image after a delay to ensure it stays changed when new popup opens
          setTimeout(function() {
            if (popupOpen && $productItem.data("image-changed")) {
              showSecondImage($productItem);
            }
          }, 200);
        } else {
          // Ensure second image is still visible
          showSecondImage($productItem);
        }
        
        // Ensure button is clickable
        $button.css({
          'pointer-events': 'auto !important',
          'z-index': '1000'
        }).prop('disabled', false).removeClass('is-disabled is-loading');
        
        // CRITICAL: Prevent default to avoid double-tap zoom, but trigger click manually
        e.preventDefault();
        
        // Check if click was already triggered to prevent double-triggering
        if ($button.data('click-triggered')) {
          return;
        }
        
        // Mark that click is being triggered
        $button.data('click-triggered', true);
        
        // Manually trigger click event to ensure theme.js handler runs
        // Use setTimeout to ensure it fires after touchend completes
        setTimeout(function() {
          try {
            var buttonElement = $button[0];
            if (!buttonElement) {
              $button.removeData('click-triggered');
              return;
            }
            
            // Ensure button is still in DOM and clickable
            if (!document.body.contains(buttonElement)) {
              $button.removeData('click-triggered');
              return;
            }
            
            // Method 1: Try native click() method first (safest)
            if (typeof buttonElement.click === 'function') {
              buttonElement.click();
            } else if (typeof MouseEvent !== 'undefined') {
              // Method 2: Synthetic MouseEvent for better compatibility
              try {
                var syntheticClick = new MouseEvent('click', {
                  bubbles: true,
                  cancelable: true,
                  view: window,
                  detail: 1
                });
                buttonElement.dispatchEvent(syntheticClick);
              } catch(syntheticErr) {
                // Fallback: Just call the click handler directly if available
                console.log('Synthetic click failed, trying direct call:', syntheticErr);
                if (buttonElement.onclick) {
                  buttonElement.onclick();
                }
              }
            }
            
            // Clear flag after short delay
            setTimeout(function() {
              $button.removeData('click-triggered');
            }, 100);
          } catch(err) {
            // Silently handle errors to prevent console spam
            // Only log if it's not a known issue
            if (err.message && !err.message.includes('observer')) {
              console.log('Click trigger failed:', err);
            }
            $button.removeData('click-triggered');
          }
        }, 50); // Increased delay to ensure DOM is ready
      }
      
      // Reset touch tracking
      touchStartElement = null;
      touchStartTime = 0;
    });
  }
  
  // DON'T add click handler on plus button - let theme.js handle it completely
  // We only handle mousedown to reset images, and collection_link to prevent navigation
  // This ensures theme.js click handler runs without interference
  
  // Reset button clicking flag after a short delay
  $(document).on("mouseup", ".quick-add__button, [data-quick-add-btn], .quick-add__holder", function(e) {
    setTimeout(function() {
      buttonClicking = false;
    }, 200);
    // Don't stop propagation - let events flow normally
  });
  
  // Track popup open/close events
  $(document).on("theme:quick-add:open", function() {
    popupOpen = true;
    $("body").addClass("quick-add-popup-open");
    // CRITICAL: DON'T reset images when popup opens - keep second image visible
    // Keep button-hover-active class to maintain second image
    // DO NOT remove button-hover-active class or reset images
    // Images will be reset ONLY when popup closes via closePopupAndReset()
    
    // CRITICAL: Ensure images stay changed - re-apply if needed with multiple delays
    // This ensures that when a new popup opens for a different product, the current product's image stays changed
    // Use multiple timeouts to ensure image stays changed even after refresh
    setTimeout(function() {
      if (popupOpen) {
        $(".grid-item.button-hover-active, .product-item.button-hover-active").each(function() {
          var $productItem = $(this);
          // Re-apply image - don't check flag, just ensure it's set
          showSecondImage($productItem);
        });
      }
    }, 50);
    
    setTimeout(function() {
      if (popupOpen) {
        $(".grid-item.button-hover-active, .product-item.button-hover-active").each(function() {
          var $productItem = $(this);
          // Re-apply image again to ensure it stays changed
          if ($productItem.data("image-changed")) {
            showSecondImage($productItem);
          }
        });
      }
    }, 200);
    
    setTimeout(function() {
      if (popupOpen) {
        $(".grid-item.button-hover-active, .product-item.button-hover-active").each(function() {
          var $productItem = $(this);
          // Final re-apply to ensure image stays changed
          if ($productItem.data("image-changed")) {
            showSecondImage($productItem);
          }
        });
      }
    }, 400);
    
    // CRITICAL: Use requestAnimationFrame to re-apply after CSS recalculation
    requestAnimationFrame(function() {
      if (popupOpen) {
        $(".grid-item.button-hover-active, .product-item.button-hover-active").each(function() {
          var $productItem = $(this);
          if ($productItem.data("image-changed")) {
            showSecondImage($productItem);
          }
        });
      }
    });
  });
  
  // Periodic check to ensure buttons are always clickable (fix for multiple click issues)
  setInterval(function() {
    // Ensure all quick-add buttons are clickable
    $(".quick-add__button, [data-quick-add-btn]").each(function() {
      var $btn = $(this);
      if (!$btn.prop('disabled') && $btn.css('pointer-events') === 'none') {
        $btn.css({
          'pointer-events': 'auto !important',
          'z-index': '1000'
        });
      }
    });
    
    // Ensure close button is always clickable
    $("[data-quick-add-modal-close], .product-quick-add__close").each(function() {
      var $btn = $(this);
      $btn.css({
        'pointer-events': 'auto !important',
        'z-index': '10000'
      }).prop('disabled', false);
    });
    
    // CRITICAL: Re-apply image styles if they were reverted (fix for opacity revert issue)
    // Check ALL products with button-hover-active, not just when popup is open
    $(".grid-item.button-hover-active, .product-item.button-hover-active").each(function() {
      var $productItem = $(this);
      if ($productItem.data("image-changed")) {
        var $hoverSecondImage = $productItem.find(".hover-second-image");
        if ($hoverSecondImage.length) {
          // Check if opacity was reverted and re-apply
          var $firstImage = $hoverSecondImage.find("a:first-child");
          var $secondImage = $hoverSecondImage.find("a:nth-child(2)");
          
          if ($firstImage.length && $secondImage.length) {
            var firstOpacity = window.getComputedStyle($firstImage[0]).opacity;
            var secondOpacity = window.getComputedStyle($secondImage[0]).opacity;
            
            // If opacity was reverted, re-apply immediately
            if (firstOpacity !== '0' || secondOpacity !== '1') {
              $firstImage.each(function() {
                try {
                  this.style.setProperty('opacity', '0', 'important');
                  this.style.opacity = '0';
                  this.setAttribute('data-opacity', '0');
                } catch(err) {}
              });
              $secondImage.each(function() {
                try {
                  this.style.setProperty('opacity', '1', 'important');
                  this.style.opacity = '1';
                  this.setAttribute('data-opacity', '1');
                } catch(err) {}
              });
              // Re-apply data attribute to ensure CSS specificity
              $productItem.attr("data-image-changed", "true");
            }
          }
        }
      }
    });
  }, 200); // Check every 200ms for faster response on iPhone
  
  // Use MutationObserver to watch for dialog open/close
  if (typeof MutationObserver !== 'undefined') {
    var checkDialogState = function() {
      var $dialog = $("dialog[data-quick-add-modal]");
      if ($dialog.length) {
        $dialog.each(function() {
          var isOpen = $(this).attr("open") !== undefined && $(this).attr("open") !== null;
          if (isOpen && !popupOpen) {
            // Dialog just opened
            popupOpen = true;
            $("body").addClass("quick-add-popup-open");
            // CRITICAL: DON'T reset images when popup opens - keep second image visible
            // DO NOT remove button-hover-active class or reset images here
            // Keep button-hover-active class to maintain second image
            // Images will be reset ONLY when popup closes via closePopupAndReset()
            
            // CRITICAL: Ensure images stay changed - re-apply if needed (fix for refresh issue)
            // This ensures that when a new popup opens for a different product, the current product's image stays changed
            // Use multiple timeouts to ensure image stays changed even after refresh
            setTimeout(function() {
              if (popupOpen) {
                $(".grid-item.button-hover-active, .product-item.button-hover-active").each(function() {
                  var $productItem = $(this);
                  // Re-apply image - don't check flag, just ensure it's set
                  showSecondImage($productItem);
                });
              }
            }, 100);
            
            setTimeout(function() {
              if (popupOpen) {
                $(".grid-item.button-hover-active, .product-item.button-hover-active").each(function() {
                  var $productItem = $(this);
                  // Re-apply image again to ensure it stays changed
                  if ($productItem.data("image-changed")) {
                    showSecondImage($productItem);
                  }
                });
              }
            }, 250);
            
            setTimeout(function() {
              if (popupOpen) {
                $(".grid-item.button-hover-active, .product-item.button-hover-active").each(function() {
                  var $productItem = $(this);
                  // Final re-apply to ensure image stays changed
                  if ($productItem.data("image-changed")) {
                    showSecondImage($productItem);
                  }
                });
              }
            }, 450);
            
            // CRITICAL: Use requestAnimationFrame to re-apply after CSS recalculation
            requestAnimationFrame(function() {
              if (popupOpen) {
                $(".grid-item.button-hover-active, .product-item.button-hover-active").each(function() {
                  var $productItem = $(this);
                  if ($productItem.data("image-changed")) {
                    showSecondImage($productItem);
                  }
                });
              }
            });
          } else if (!isOpen && popupOpen) {
            // Dialog just closed
            setTimeout(function() {
              closePopupAndReset();
            }, 150);
          }
        });
      }
    };
    
    // Check immediately and then periodically
    checkDialogState();
    setInterval(checkDialogState, 200);
    
    // Also observe dialog attribute changes
    var dialogObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
          checkDialogState();
        }
      });
    });
    
    // Observe existing dialogs
    $(document).ready(function() {
      $("dialog[data-quick-add-modal]").each(function() {
        dialogObserver.observe(this, { attributes: true, attributeFilter: ['open'] });
      });
    });
    
    // Watch for new dialogs being added
    var bodyObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) {
            var $dialogs = $(node).find("dialog[data-quick-add-modal]").addBack("dialog[data-quick-add-modal]");
            $dialogs.each(function() {
              dialogObserver.observe(this, { attributes: true, attributeFilter: ['open'] });
              checkDialogState();
            });
          }
        });
      });
    });
    
    $(document).ready(function() {
      bodyObserver.observe(document.body, { childList: true, subtree: true });
    });
  }
  
  // Function to reset image to first image - reusable
  function resetToFirstImage($productItem) {
    try {
      var $hoverSecondImage = $productItem.find(".hover-second-image");
      if ($hoverSecondImage.length) {
        // Show first image (opacity 1)
        var $firstImage = $hoverSecondImage.find("a:first-child");
        if ($firstImage.length) {
          $firstImage.each(function() {
            try {
              this.style.setProperty('opacity', '1', 'important');
            } catch(err) {
              // Silently handle errors
            }
          });
        }
        // Hide second image (opacity 0)
        var $secondImage = $hoverSecondImage.find("a:nth-child(2)");
        if ($secondImage.length) {
          $secondImage.each(function() {
            try {
              this.style.setProperty('opacity', '0', 'important');
            } catch(err) {
              // Silently handle errors
            }
          });
        }
      }
      // Also reset product-item__bg__under for compatibility
      $productItem.find(".product-item__bg__under").css("opacity", "");
      // Remove button hover active class
      $productItem.removeClass("button-hover-active");
      // Clear the image changed flag
      $productItem.removeData("image-changed");
    } catch(err) {
      // Silently handle errors
    }
  }
  
  // Function to close popup and reset state
  function closePopupAndReset() {
    popupOpen = false;
    $("body").removeClass("quick-add-popup-open");
    
    // Reset all images back to first image when popup closes
    $(".grid-item, .product-item").each(function() {
      resetToFirstImage($(this));
    });
  }
  
  // Reset images when close button is clicked (before popup closes)
  // Use mousedown to prepare for close
  $(document).on("mousedown", "[data-quick-add-modal-close], .product-quick-add__close", function(e) {
    var $closeBtn = $(this);
    
    // Mark that we're closing to prevent hover
    buttonClicking = true;
    popupOpen = false;
    $("body").removeClass("quick-add-popup-open");
    
    // CRITICAL: Ensure close button is always clickable
    $closeBtn.css({
      'pointer-events': 'auto !important',
      'z-index': '10000'
    }).prop('disabled', false);
    
    setTimeout(function() {
      buttonClicking = false;
    }, 500);
    
    // Don't prevent default or stop propagation - let theme.js handle the close
  });
  
  // iOS/iPhone specific: Handle touchstart to prevent hover effects on close button
  if ('ontouchstart' in window) {
    var closeTouchStartTime = 0;
    var closeTouchStartElement = null;
    
    $(document).on("touchstart", "[data-quick-add-modal-close], .product-quick-add__close", function(e) {
      var $closeBtn = $(this);
      
      // Store touch info
      closeTouchStartTime = Date.now();
      closeTouchStartElement = this;
      
      // Mark that we're closing to prevent hover
      buttonClicking = true;
      popupOpen = false;
      $("body").removeClass("quick-add-popup-open");
      
      // DON'T reset images on touchstart - wait for touchend/click to prevent image change on first touch
      // Images will be reset in touchend or click handler
      
      // Ensure close button is clickable
      $closeBtn.css({
        'pointer-events': 'auto !important',
        'z-index': '10000'
      }).prop('disabled', false);
    });
    
    // Handle touchend for immediate close on iOS
    $(document).on("touchend", "[data-quick-add-modal-close], .product-quick-add__close", function(e) {
      var $closeBtn = $(this);
      var touchDuration = Date.now() - closeTouchStartTime;
      
      // Only handle if this is the same element and quick touch
      if (closeTouchStartElement === this && touchDuration < 500) {
        // Mark popup as closing
        popupOpen = false;
        $("body").removeClass("quick-add-popup-open");
        buttonClicking = true;
        
        // Reset all images back to first image when closing
        $(".grid-item, .product-item").each(function() {
          resetToFirstImage($(this));
        });
        
        // Ensure close button is clickable
        $closeBtn.css({
          'pointer-events': 'auto !important',
          'z-index': '10000'
        }).prop('disabled', false);
        
        // CRITICAL: Manually trigger click to ensure theme.js handler runs on first touch
        setTimeout(function() {
          try {
            var closeButtonElement = $closeBtn[0];
            if (closeButtonElement && document.body.contains(closeButtonElement)) {
              // Trigger click event to ensure theme.js handler runs
              if (typeof closeButtonElement.click === 'function') {
                closeButtonElement.click();
              } else {
                // Fallback: Synthetic MouseEvent
                var syntheticClick = new MouseEvent('click', {
                  bubbles: true,
                  cancelable: true,
                  view: window,
                  detail: 1
                });
                closeButtonElement.dispatchEvent(syntheticClick);
              }
            }
          } catch(err) {
            // Silently handle errors
          }
        }, 10);
        
        setTimeout(function() {
          buttonClicking = false;
        }, 500);
        
        // CRITICAL: Prevent default to avoid double-tap zoom, but we've already triggered click
        e.preventDefault();
        e.stopPropagation();
      }
      
      // Reset touch tracking
      closeTouchStartElement = null;
      closeTouchStartTime = 0;
    });
  }
  
  // Also handle close button click - reset images but don't interfere with close
  // This works for both mouse and touch (touch fires click after touchend)
  $(document).on("click", "[data-quick-add-modal-close], .product-quick-add__close", function(e) {
    var $closeBtn = $(this);
    
    // Mark popup as closing immediately
    popupOpen = false;
    $("body").removeClass("quick-add-popup-open");
    buttonClicking = true;
    
    // Reset all images back to first image when closing
    $(".grid-item, .product-item").each(function() {
      resetToFirstImage($(this));
    });
    
    // CRITICAL: Ensure close button is always clickable
    $closeBtn.css({
      'pointer-events': 'auto !important',
      'z-index': '10000'
    }).prop('disabled', false);
    
    setTimeout(function() {
      buttonClicking = false;
    }, 500);
    
    // Don't prevent default or stop propagation - theme.js handles the actual close
  });
  
  // Listen for when dialog actually closes
  $(document).on("close", "dialog[data-quick-add-modal]", function() {
    setTimeout(function() {
      closePopupAndReset();
    }, 200);
  });
  
  // Listen for animation end on dialog closing
  $(document).on("animationend", "dialog[data-quick-add-modal]", function(e) {
    // Check if dialog is actually closed
    if (!$(this).attr("open") || $(this).attr("closing")) {
      setTimeout(function() {
        closePopupAndReset();
      }, 50);
    }
  });
  
  // Reset on ESC key
  $(document).on("keydown", function(e) {
    if (e.keyCode === 27 && popupOpen) { // ESC key
      // closePopupAndReset will handle image reset
      setTimeout(function() {
        closePopupAndReset();
      }, 200);
    }
  });


  // $('.size-option').on('click', function () {
  //   $('.size-option').removeClass('active');
  //   $(this).addClass('active');

  //   // Enable the Add to Cart button
  //   $('.add-to-cart')
  //     .prop('disabled', false)
  //     .addClass('enabled');
  // });





  
});

$(document).ready(function () {
  // function toggleReadMore() {
  //   var content = $(".landingpage-text p span");
  //   var fullText = content.data("full-text") || content.html(); // Store full content
  //   var maxLength = fullText.indexOf("<br>"); // Cut off at first <br>
  //   var windowWidth = $(window).width();

  //   // Save full text if not already stored
  //   if (!content.data("full-text")) {
  //     content.data("full-text", fullText);
  //   }

  //   if (windowWidth <= 768) {
  //     // Mobile only
  //     if (maxLength !== -1) {
  //       var shortText = fullText.substring(0, maxLength);

  //       content.html(
  //         shortText + '... <a href="#" class="read-more">Read more</a>'
  //       );

  //       $(".landingpage-text")
  //         .off("click")
  //         .on("click", ".read-more", function (e) {
  //           e.preventDefault();
  //           content.html(
  //             fullText + ' <a href="#" class="read-less">Read less</a>'
  //           );
  //         });

  //       $(".landingpage-text").on("click", ".read-less", function (e) {
  //         e.preventDefault();
  //         content.html(
  //           shortText + '... <a href="#" class="read-more">Read more</a>'
  //         );
  //       });
  //     }
  //   } else {
  //     // Reset content when switching back to desktop
  //     content.html(fullText);
  //   }
  // }

  // toggleReadMore(); // Run on page load
  // $(window).resize(function () {
  //   setTimeout(toggleReadMore, 100); // Delay to avoid flickering
  // });

  function toggleReadMore() {
    var content = $(".landingpage-text p span");

    // Check if the element exists
    if (content.length === 0) {
      return; // Stop execution if element is not found
    }

    var fullText = content.data("full-text") || content.html().trim(); // Ensure content is valid
    var maxLength = fullText.indexOf("<br>"); // Find first <br> tag
    var windowWidth = $(window).width();

    // Save full text if not already stored
    if (!content.data("full-text")) {
      content.data("full-text", fullText);
    }

    if (windowWidth <= 768) {
      // Mobile only
      if (maxLength !== -1) {
        var shortText = fullText.substring(0, maxLength);

        content.html(
          shortText + '... <a href="#" class="read-more">Read more</a>'
        );

        $(".landingpage-text")
          .off("click")
          .on("click", ".read-more", function (e) {
            e.preventDefault();
            content.html(
              fullText + ' <a href="#" class="read-less">Read less</a>'
            );
          });

        $(".landingpage-text").on("click", ".read-less", function (e) {
          e.preventDefault();
          content.html(
            shortText + '... <a href="#" class="read-more">Read more</a>'
          );
        });
      }
    } else {
      // Reset content when switching back to desktop
      content.html(fullText);
    }
  }

  // Run only when the document is fully loaded
  $(document).ready(function () {
    toggleReadMore();
  });

  // Run on window resize (with delay to prevent flickering)
  $(window).resize(function () {
    setTimeout(toggleReadMore, 100);
  });

  $(".notify_me_click").on("click", function () {
    $(".bis-button").trigger("click");
  });

  /*--------------- mobile image slick slider ----------*/
$(".mobile-menu-image-slider").slick({
  slidesToShow: 2.1,
  slidesToScroll: 1,
  arrows: false,
  dots: false,
  infinite: true,
  swipeToSlide: true
});
  $(".header__mobile__hamburger").on("click", function () {
    $(".mobile-menu-image-slider").slick("setPosition");
  });
  // $(".mobile-slider").slick({
  //   slidesToShow: 2,
  //   slidesToScroll: 1,
  //   arrows: false,
  //   dots: false,
  //   speed: 300,
  //   infinite: true,
  //   autoplaySpeed: 5000,
  //   autoplay: false,
  // });
  /*--------------- mobile menu accordian ----------*/

// $(document).ready(function () {
//   // Open the first accordion section by default
//   $(".accordion_head").first().addClass("active");
//   $(".accordion_body").first().slideDown(0);
//   $(".accordion_head").first().find(".plusminus").attr(
//     "src",
//     "https://cdn.shopify.com/s/files/1/0284/7355/7064/files/svgexport-14_3.svg?v=1728983909"
//   );

//   $(".accordion_head").click(function () {
//     // If already open, do nothing
//     if ($(this).hasClass("active")) {
//       return;
//     }

//     // Remove active class and collapse all
//     $(".accordion_head").removeClass("active");
//     $(".accordion_body").slideUp(300);
//     $(".plusminus").attr(
//       "src",
//       "https://cdn.shopify.com/s/files/1/0284/7355/7064/files/svgexport-14_2.svg?v=1728983909"
//     );

//     // Open the clicked one
//     $(this).addClass("active");
//     $(this).next(".accordion_body").slideDown(300);
//     $(this).children(".plusminus").attr(
//       "src",
//       "https://cdn.shopify.com/s/files/1/0284/7355/7064/files/svgexport-14_3.svg?v=1728983909"
//     );
//   });
// });


  $(".accordion_head").click(function () {
    // Remove 'active' class from all accordion heads
    $(".accordion_head").removeClass("active");
    // Slide up all accordion bodies
    $(".accordion_body").slideUp(300);
    $(".plusminus").attr(
      "src",
      "https://cdn.shopify.com/s/files/1/0284/7355/7064/files/svgexport-14_2.svg?v=1728983909"
    );

    // Check if the clicked accordion body is already visible
    if ($(this).next(".accordion_body").is(":visible")) {
      $(this).next(".accordion_body").slideUp(300);
      $(this)
        .children(".plusminus")
        .attr(
          "src",
          "https://cdn.shopify.com/s/files/1/0284/7355/7064/files/svgexport-14_2.svg?v=1728983909"
        );
    } else {
      $(this).addClass("active"); // Add 'active' class to the clicked header
      $(this).next(".accordion_body").slideDown(300);
      $(this)
        .children(".plusminus")
        .attr(
          "src",
          "https://cdn.shopify.com/s/files/1/0284/7355/7064/files/svgexport-14_3.svg?v=1728983909"
        );
    }
  });
  

  $(".product-item__image a").on("click", function (event) {
    // Check if the screen size is mobile
    if ($(window).width() <= 768) {
      const $parentImage = $(this).closest(".product-item__image");
      window.location.href = $(this).attr("href");
    }
  });

  // Step 4: Prevent collection link navigation when clicking on quick-add button
  // Since collection_link is a sibling (not parent), we need to check if the click
  // is happening near the button area and prevent navigation
  $(document).on("click", ".collection_link", function (event) {
    var $target = $(event.target);
    var $gridItem = $(this).closest(".grid-item, .product-item");
    
    // Check if there's a quick-add button in the same grid item that was recently clicked
    // We use a data attribute set on mousedown to track this
    if ($gridItem.data("quick-add-clicked")) {
      event.preventDefault();
      $gridItem.find(".product-item__bg__under").css("opacity", "");
      $gridItem.removeData("quick-add-clicked");
      return false;
    }
  });
  
  // Step 5: iOS Safari support - Handle touch events properly
  // Don't interfere with the button's own event handlers
  if ('ontouchstart' in window) {
    $(document).on("touchend", ".collection_link", function (event) {
      var target = event.target;
      var $target = $(target);
      
      // If touch ended on quick-add button, prevent collection link action
      if ($target.closest('.quick-add__button, .quick-add__holder, [data-quick-add-btn]').length) {
        event.preventDefault();
        event.stopPropagation();
        // Reset hover image
        $(this).parent(".grid-item").find(".product-item__bg__under").css("opacity", "");
        return false;
      }
    });
  }
  
  // Prevent hover from triggering when mouse moves over plus button area
  $(document).on("mouseenter", ".quick-add__button, [data-quick-add-btn], .quick-add__holder", function(e) {
    var $productItem = $(this).closest(".grid-item, .product-item");
    // CRITICAL: Add class FIRST to prevent hover from triggering
    $productItem.addClass("button-hover-active");
    
    // For non-touchable devices: Revert to first image when plus icon is hovered
    if (!isTouchDevice()) {
      var $bgUnder = $productItem.find(".product-item__bg__under");
      var $hoverSecondImage = $productItem.find(".hover-second-image");
      
      // Revert to first image (stop image change) - use setProperty with important
      if ($hoverSecondImage.length) {
        var $firstImage = $hoverSecondImage.find("a:first-child");
        var $secondImage = $hoverSecondImage.find("a:nth-child(2)");
        if ($firstImage.length && $secondImage.length) {
          // Show first image, hide second image with !important
          $firstImage.each(function() {
            this.style.setProperty('opacity', '1', 'important');
          });
          $secondImage.each(function() {
            this.style.setProperty('opacity', '0', 'important');
          });
        }
      }
      // Also revert product-item__bg__under with !important
      if ($bgUnder.length) {
        $bgUnder.each(function() {
          this.style.setProperty('opacity', '0', 'important');
        });
      }
    }
    e.stopPropagation();
  });
  
  $(document).on("mouseleave", ".quick-add__button, [data-quick-add-btn], .quick-add__holder", function(e) {
    var $productItem = $(this).closest(".grid-item, .product-item");
    var relatedTarget = e.relatedTarget || document.activeElement;
    var $relatedTarget = $(relatedTarget);
    
    // Check if mouse is moving to collection_link area within the same product item
    var isMovingToCollectionLink = $relatedTarget.closest('.collection_link').length > 0 &&
                                   $relatedTarget.closest('.grid-item, .product-item').is($productItem);
    
    // Check if mouse is still over the product item
    var isStillOverProductItem = $productItem.is($relatedTarget.closest('.grid-item, .product-item'));
    
    // Only remove the marker if button is not being clicked and not moving to collection_link or product item
    if (!buttonClicking && !isMovingToCollectionLink && !isStillOverProductItem) {
      setTimeout(function() {
        // Check again before removing - if mouse is now over collection_link or product item, keep the class
        if (!$productItem.find('.collection_link:hover').length && !$productItem.is(':hover')) {
          $productItem.removeClass("button-hover-active");
          // If not hovering over collection_link or product item, reset image
          if (!isTouchDevice()) {
            var $hoverSecondImage = $productItem.find(".hover-second-image");
            if ($hoverSecondImage.length) {
              var $firstImage = $hoverSecondImage.find("a:first-child");
              var $secondImage = $hoverSecondImage.find("a:nth-child(2)");
              if ($firstImage.length && $secondImage.length) {
                $firstImage.css("opacity", "");
                $secondImage.css("opacity", "");
              }
            } else {
              $productItem.find(".product-item__bg__under").css("opacity", "");
            }
          }
        } else if ($productItem.is(':hover') && !$productItem.find('.quick-add__button:hover, [data-quick-add-btn]:hover').length) {
          // Mouse is back over product item (but not plus icon), show second image again
          $productItem.removeClass("button-hover-active");
          if (!isTouchDevice()) {
            var $hoverSecondImage = $productItem.find(".hover-second-image");
            if ($hoverSecondImage.length) {
              var $firstImage = $hoverSecondImage.find("a:first-child");
              var $secondImage = $hoverSecondImage.find("a:nth-child(2)");
              if ($firstImage.length && $secondImage.length) {
                // Remove inline styles to let CSS handle it
                $firstImage.each(function() {
                  this.style.removeProperty('opacity');
                });
                $secondImage.each(function() {
                  this.style.removeProperty('opacity');
                });
              }
            }
            // Remove inline style from product-item__bg__under
            $productItem.find(".product-item__bg__under").each(function() {
              this.style.removeProperty('opacity');
            });
          }
        }
      }, 100);
    }
    e.stopPropagation();
  });
  
  // Also prevent hover when button is focused or active
  $(document).on("focus focusin", ".quick-add__button, [data-quick-add-btn]", function(e) {
    var $productItem = $(this).closest(".grid-item, .product-item");
    $productItem.addClass("button-hover-active");
    $productItem.find(".product-item__bg__under").css("opacity", "");
  });
  
});

// sort button in drawer
$(document).on("click", ".popout-list-option-drawer", function (event) {
  event.preventDefault();
  let dataVal = $(this).attr("data-value-option");
  console.log(dataVal, "dataVal---");
  let targetElement = $(`[data-value="${dataVal}"]`).get(0);
  console.log(targetElement, "trigger---");

  $(`[data-value="${dataVal}"]`).get(0).click();
});




$(document).on('click', '.product-quick-add__form .radio__button input[type="radio"]', function () {
  const $group = $(this).closest('.radio__buttons');

  // Remove active from all and add to clicked one
  $group.find('.radio__button').removeClass('active');
  $(this).closest('.radio__button').addClass('active');

  // Get the whole form
  const $form = $(this).closest('.product-quick-add__form');

  // Show the real Add to Cart button
  const $addToCartBtn = $form.find('#add--cart-btn-pro');
  const $selectSizeBtn = $form.find('.select--size');
  const $btnText = $addToCartBtn.find('.btn__text');

  $addToCartBtn.css('display', 'block');
  $selectSizeBtn.css('display', 'none');

  // Update the text based on disabled state
  setTimeout(function () {
    if ($addToCartBtn.prop('disabled')) {
      $btnText.text('Sold Out');
    } else {
      $btnText.text('Add to cart');
    }
  }, 100); // delay in case button disabled status updates after radio click
});


$(document).ready(function () {
  $('.form__wrapper').each(function () {
    const $wrapper = $(this);
    const $radioWrapper = $wrapper.find('.product__block .radio__buttons_2');
    const $addToCartBtn = $wrapper.find('#add--cart-btn-pro');
    const $selectSizeBtn = $wrapper.find('.select--size');
    const $btnText = $addToCartBtn.find('.btn__text');

    // Only if .radio__buttons_2 NOT found → show Add to cart
    if ($radioWrapper.length === 0) {
      $addToCartBtn.css('display', 'block');
      $selectSizeBtn.css('display', 'none');

      if ($addToCartBtn.prop('disabled')) {
        $btnText.text('Sold Out');
      } else {
        $btnText.text('Add to cart');
      }
    } else {
      // If size option exists, force select size
      $addToCartBtn.css('display', 'none');
      $selectSizeBtn.css('display', 'block');
    }
  });
});

$(document).on('click', '.form__wrapper .radio__button input[type="radio"]', function () {
  const $radio = $(this);
  const $formWrapper = $radio.closest('.form__wrapper');

  // 1. Set active style
  $formWrapper.find('.radio__button').removeClass('active');
  $radio.closest('.radio__button').addClass('active');

  // 2. Toggle buttons
  const $addToCartBtn = $formWrapper.find('#add--cart-btn-pro');
  const $selectSizeBtn = $formWrapper.find('.select--size');
  const $btnText = $addToCartBtn.find('.btn__text');

  $addToCartBtn.css('display', 'block');
  $selectSizeBtn.css('display', 'none');

  // 3. Text logic
  setTimeout(function () {
    if ($addToCartBtn.prop('disabled')) {
      $btnText.text('Sold Out');
    } else {
      $btnText.text('Add to cart');
    }
  }, 100);
});

setInterval(function () {
  if ($('.cart-bar').hasClass('is-visible')) {
    $('body').addClass('cart-bar-visible-padding');
  } else {
    $('body').removeClass('cart-bar-visible-padding');
  }
}, 300); // runs every 300ms
setInterval(function () {
  if ($('.cart-bar').hasClass('is-visible')) {
    $('body').addClass('cart-bar-visible-padding');
  } else {
    $('body').removeClass('cart-bar-visible-padding');
  }
}, 300); // runs every 300ms
